import { userConstants, apiConstants } from '../constants';
import url from '../../helpers/url';
import history from '../../helpers/history';

export const userLogin = ({ email, password, from }) => ({
    type: apiConstants.API,
    payload: {
        url: url.login,
        method: 'POST',
        body: {
            email,
            password
        },
        request: () => ({ type: userConstants.LOGIN_REQUEST }),
        success: (data) => ({ type: userConstants.LOGIN_SUCCESS, data }),
        failure: (error) => ({ type: userConstants.LOGIN_FAILURE, error }),
        formatData: (data) => ({ ...data[0] }),
        progress: {
            success: {
                intent: 'welcome',
                message: (data) => `Welcome ${data.first_name} ${data.last_name}!`
            }
        },
        redirect: {
            success: () => history.push(from)
        }
    }
});

export const userCheckLogin = (data) => {
    return dispatch => dispatch({ type: userConstants.LOGIN_SUCCESS, data })
}

export const userLogout = () => ({
    type: apiConstants.API,
    payload: {
        url: url.logout,
        method: 'POST',
        request: () => ({ type: userConstants.LOGOUT_REQUEST }),
        redirect: {
            success: () => history.push('/login')
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/actions/user.actions.js